<template>
	<span style="line-height: 30px" v-if="total && pageSize && currentPage">
		<el-pagination style="display: inline-block" :background="background" :layout="layout"
			:page-sizes="pageSizes" @current-change="pageChange" @size-change="sizeChange"
			:total="total" :page-size="pageSize"
			:current-page="currentPage"/>
		<span>
			<el-input-number :controls="false" :step="1" step-strictly :min="1" :max="maxPage"
				size="mini" @keyup.enter.native="pageChange(jumperPage)" v-model="jumperPage" style="width: 50px"></el-input-number>
			&nbsp;
			<el-button type="primary" size="mini" @click="pageChange(jumperPage)">GO</el-button>
		</span>
	</span>
</template>

<script>
export default {
	name: "pageSub",
	data() {
		return {
			jumperPage : null
		}
	},
	computed : {
		maxPage(){
			return Math.ceil(this.total / this.pageSize)
		}
	},
	props: {
		pageSizes: {},
		layout : {
			default:  "sizes,prev, pager,next"
		},
		background : {
			default : false
		},
		total : {
			type : Number
		},
		pageSize : {
			required :true,
			type : Number
		},
		currentPage : {
			required :true,
			type : Number
		},
		placement : {
			default : 'top-start'
		}
	},
	created() {
		this.$data.jumperPage = this.currentPage
		if (this.layout.indexOf('jumper')){
			let arr = this.layout.split (',')
			arr = arr.filter(i => i !== 'jumper')
			this.layout = arr.toString()
		}
	},
	methods : {
		pageChange : function(val) {
			val = val || 1
			this.$emit('current-change',val)
		},
		sizeChange : function(val) {
			val = val || 1
			this.$emit('size-change',val)
		}
	},
	watch : {
		currentPage : {
			handler(val){
				this.$data.jumperPage = val
			}
		}
	}
}
</script>

<style scoped>

</style>